import { isStandingPromoCode } from "~~/shared/utils/standingPromo";

/**
 * Akcja „stałe kody rabatowe od wartości zamówienia" dla aktualnej marki.
 * Konfiguracja siedzi w brandzie (app/brands/<brand>/config.ts) — marka bez sekcji
 * `standingPromo` nie prowadzi akcji i blok kodów się nie renderuje.
 */
export function useStandingPromo() {
  const brand = useBrand();
  const config = computed(() => brand.standingPromo ?? null);

  /**
   * Akcja wystartowała. Liczone przez `Date.now()` także na SSR — blok kodów jest
   * statyczny (bez licznika), więc chwilowo nieaktualna wartość z edge-cache nie
   * powoduje CLS-u; klient poprawia ją przy hydracji.
   */
  const isActive = computed(() => {
    const cfg = config.value;
    if (!cfg) return false;
    if (!cfg.startsAt) return true;
    const startsAt = new Date(cfg.startsAt).getTime();
    return Number.isNaN(startsAt) ? true : Date.now() >= startsAt;
  });

  const codes = computed(() => config.value?.codes.map((c) => c.code) ?? []);

  /** Najwyższy próg — wyróżniany w UI (ostatni na liście). */
  const bestCode = computed(() => codes.value[codes.value.length - 1] ?? null);

  /**
   * Czy kod należy do akcji. NIE bramkowane `isActive` — kupony tej rodziny trzeba
   * chować w „promo notices" karty produktu niezależnie od tego, czy panel już wisi.
   */
  function isStandingCode(code: string | null | undefined): boolean {
    return isStandingPromoCode(code, codes.value);
  }

  return { config, isActive, codes, bestCode, isStandingCode };
}
